module.exports = __webpack_public_path__ + "static/media/precise2.0b326f76.jpg";